import React from 'react';
import styles from './yandex-integration.module.scss';

export const YandexIntegration: React.FC = () => {
  return (
    <div className={styles.yandex_outer}>
      <div className={styles.yandex_inner}>
        <h2 className={styles.yandex_title}>
          Интеграция с Яндекс Картами бесплатно
        </h2>
        <div className={styles.yandex_subtitle}>
          Подключим ваш салон к Яндекс Картам бесплатно по запросу на{' '}
          <a href="mailto:integration@book-up.ru">integration@book-up.ru</a>
        </div>

        <div className={styles.yandex_benefits}>
          <div className={styles.benefit_card}>
            <div className={styles.benefit_icon}>📍</div>
            <div className={styles.benefit_title}>Кнопка на Яндекс Картах</div>
            <div className={styles.benefit_text}>
              Клиенты записываются прямо из поиска Яндекса
            </div>
          </div>

          <div className={styles.benefit_card}>
            <div className={styles.benefit_icon}>👥</div>
            <div className={styles.benefit_title}>Новые клиенты</div>
            <div className={styles.benefit_text}>
              Приток клиентов из Яндекс Карт и поиска
            </div>
          </div>

          <div className={styles.benefit_card}>
            <div className={styles.benefit_icon}>⚡</div>
            <div className={styles.benefit_title}>Быстрое подключение</div>
            <div className={styles.benefit_text}>
              Настроим интеграцию за 1-2 рабочих дня
            </div>
          </div>
        </div>

        <div className={styles.yandex_steps}>
          <h3>Как это работает</h3>
          <div className={styles.steps_list}>
            <div className={styles.step}>
              <div className={styles.step_number}>1</div>
              <div className={styles.step_text}>
                Напишите нам на{' '}
                <a href="mailto:integration@book-up.ru">
                  integration@book-up.ru
                </a>
              </div>
            </div>
            <div className={styles.step}>
              <div className={styles.step_number}>2</div>
              <div className={styles.step_text}>
                Мы проверим ваш профиль в Яндекс Картах
              </div>
            </div>
            <div className={styles.step}>
              <div className={styles.step_number}>3</div>
              <div className={styles.step_text}>
                Настроим интеграцию и протестируем
              </div>
            </div>
            <div className={styles.step}>
              <div className={styles.step_number}>4</div>
              <div className={styles.step_text}>
                Кнопка &ldquo;Записаться&rdquo; появляется на вашей карточке
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
